export const FeatureFlags = {
  AML_CONTACT_DETAILS: { key: 'aml-contact-details', defaultValue: false },
  AML_SIGNUP_RISK_ASSESSMENT: { key: 'aml-signup-risk-assessment', defaultValue: false },
  KAMBI_MAINTENANCE: { key: 'kambi-maintenance', defaultValue: {} },
  REBET_TAB: { key: 're-bet-tab', defaultValue: false },
  BONUS_CASH_IMPROVEMENTS: { key: 'bonus-cash-improvements', defaultValue: false },
  WITHDRAW_REALTIME: { key: 'withdraw-realtime', defaultValue: false },
  PENDING_BETS_FOR_RACE: { key: 'pending-bets-for-race', defaultValue: false },
  FIELD_SUMMARY_V2: { key: 'field-summary-v2', defaultValue: false },
  RACING_WA_VISION_CHANNEL: { key: 'racing-wa-vision-channel', defaultValue: false },
  RACE_REPLAY_IMPROVEMENTS: { key: 'race-replay-improvements', defaultValue: false },
  AUTO_REFRESH_ON_VERSION_CHANGE: { key: 'auto-refresh-on-version-change', defaultValue: false },
  RACE_CARD_REACT_REWRITE: { key: 'race-card-react-rewrite', defaultValue: false },
  WITHDRAW_REALTIME_INTERNAL_USER_MODE: {
    key: 'withdraw-realtime-internal-user-mode',
    defaultValue: false,
  },
  FAST_WITHDRAW_MARKETING_BANNER: {
    key: 'fast-withdraw-marketing-banner',
    defaultValue: false,
  },

  BET_LOOP: { key: 'content-hub-follow-me', defaultValue: false },
  BET_LOOP_SPORTS: { key: 'bet-loop-sports', defaultValue: false },

  KAMBI_SPORTS_OFFERING_INTEGRATION: {
    key: 'kambi-sports-offering-integration',
    defaultValue: false,
  },

  TEMP_DISABLE_EDIT_CONTACT_DETAILS: {
    key: 'temporary-disabling-edit-contact-details-and-bank-account',
    defaultValue: false,
  },
  MFA_OPT_IN_BANNER: {
    key: 'mfa-opt-in-banner-v2',
    defaultValue: 'off', // 'on_if_recent_login', 'on'
  },
  GET_CAMPAIGNS_V2: { key: 'get-campaigns-v2', defaultValue: false },
  SPLIT_BONUS_BETS: { key: 'split-bonus-bets', defaultValue: false },
  QUALTRICS_INSIGHTS: { key: 'qualtrics-insights', defaultValue: false },
  EMAIL_LOGIN: { key: 'email-login', defaultValue: false },
  MFA_IN_SIGNUP: {
    key: 'mfa-in-signup',
    defaultValue: 'off', // 'verify' | 'verify_and_enable'
  },
  API_MIGRATION_STAGES: { key: 'api-migration-stages', defaultValue: {} },
  VENUE_MODE: { key: 'venue-mode', defaultValue: false },
  VENUE_MODE_DIAGNOSTICS: { key: 'venue-mode-diagnostics', defaultValue: false },
  VENUE_MODE_BROWSER: { key: 'venue-mode-browser', defaultValue: false },
  VENUE_MODE_OUTSIDE_EVENT_COUNT: { key: 'venue-mode-outside-event-count', defaultValue: 1 },
  VENUE_MODE_AGENCIES: { key: 'venue-mode-agencies', defaultValue: '' },
  DYNAMICS_PUSH_DEVELOPER_MODE: { key: 'dynamics-push-developer-mode', defaultValue: false },
  DYNAMICS_PUSH_REGISTRATION: { key: 'dynamics-push-registration', defaultValue: false },
  IN_APP_MARKETING: { key: 'dynamics-in-app-marketing', defaultValue: false },
  TRANSACTION_HISTORY_STATEMENTS: { key: 'transaction-history-statements', defaultValue: false },
  NEW_PREVIEW_TIPS_LAYOUT: {
    key: 'new-preview-tips-layout',
    defaultValue: false,
  },
} as const

export type FeatureFlagValue = string | number | boolean | Record<string, unknown> | undefined

export type FeatureFlagType = { key: FeatureFlagKeyName; defaultValue: FeatureFlagValue }

type FF = typeof FeatureFlags
type FeatureFlagsKeys = keyof FF

export type FeatureFlagKeyName = FF[FeatureFlagsKeys]['key']

type FeatureKeyExtract<TKey extends FeatureFlagKeyName> = {
  [K in keyof FF]: FF[K]['key'] extends TKey ? K : never
}[keyof FF]

export type FeatureValueType<TKey extends FeatureFlagKeyName> =
  FF[FeatureKeyExtract<TKey>] extends { key: infer U; defaultValue: infer V }
    ? U extends TKey
      ? V extends boolean
        ? boolean
        : V extends string
          ? string
          : V extends number
            ? number
            : V
      : never
    : never

type FeatureFlagDefaults = { [K in FeatureFlagKeyName]: FeatureValueType<K> }

export function getFlagDefaults(): FeatureFlagDefaults {
  return (Object.keys(FeatureFlags) as FeatureFlagsKeys[]).reduce((accumulator, flag) => {
    const { key, defaultValue } = FeatureFlags[flag]
    accumulator[key] = defaultValue

    return accumulator
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any)
}

export const featureDefaults = getFlagDefaults()
